import Bank from "@repo/icons/default/Bank";
import Left from "@repo/icons/default/Left";
import User1 from "@repo/icons/default/User1";
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { MenuList, type MenuListItem } from "@/components/ui/layout/menu/menu-list";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ChangeOwnershipDrawer } from "@/components/payment/ownership/change-ownership-drawer";
import { ChangeBankingInstitutionDrawer } from "@/components/payment/bank/account/change-banking-institution";

import type { JSX } from "react";

const changeBankAccountActionSchema = z.object({
  action: z.string().optional(),
});

const ChangeBankAccountOrOwnershipPage = (): JSX.Element => {
  const searchParams = useSearch({
    from: "/settings/payments/bank-account/change-bank-account-or-ownership",
  });

  const { action } = searchParams;
  const router = useRouter();

  const menuItems: MenuListItem[] = [
    {
      name: "Trocar titularidade",
      Icon: User1,
      route: "/settings/payments/bank-account/change-bank-account-or-ownership",
      search: {
        action: "change-ownership",
        ...searchParams,
      },
      description:
        "Alterar a titularidade do meu recebedor entre Pessoa Física (PF) e Pessoa Jurídica (PJ)",
    },
    {
      name: "Trocar instituição bancária",
      Icon: Bank,
      route: "/settings/payments/bank-account/change-bank-account-or-ownership",
      search: {
        action: "change-bank-account",
        ...searchParams,
      },
      description: "Manter minha titularidade e alterar dados da minha conta ou banco.",
    },
  ];

  const handleDrawerActions = (
    value: boolean,
    actionString: "change-ownership" | "change-bank-account",
  ): void => {
    if (!value && action === actionString) {
      router.history.back();
    }
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Conta para recebimento" align="center" />
      </HeaderRoot>
      <Page className="pt-2">
        <h1 className="text-xl font-medium text-neutral-600 my-2">
          O que deseja alterar?
        </h1>
        <MenuList menuItems={menuItems} />

        <ChangeOwnershipDrawer
          open={action === "change-ownership"}
          setOpen={(value) => handleDrawerActions(value, "change-ownership")}
        />
        <ChangeBankingInstitutionDrawer
          open={action === "change-bank-account"}
          setOpen={(value) => handleDrawerActions(value, "change-bank-account")}
        />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/bank-account/change-bank-account-or-ownership",
)({
  component: ChangeBankAccountOrOwnershipPage,
  validateSearch: changeBankAccountActionSchema,
});
